import React, { useState } from "react";
import { FilterIcon, MinusIcon, PLusIcon, RemoveIcon, SearchIcon } from "../../Assets/Icons";

const FilterTab = ({
  selectedCheckboxes = [],
  setSelectedCheckboxes,
  filterOptions,
  onToggleFilter,
  showfilter,
  handleResetCheckBox,
}) => {
  const [sortingOpen, setSortingOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentTab, setCurrentTab] = useState(null);

  const handleCheckboxChange = (item) => {
    if (setSelectedCheckboxes) setSelectedCheckboxes(item);
  };

  const isChecked = (item) => {
    return selectedCheckboxes.find((value) => value.value === item.value) ? true : false;
  };

  const openSorting = () => {
    setSortingOpen(!sortingOpen);
  };

  const handleReset = () => {
    if (handleResetCheckBox) handleResetCheckBox();
    setSearchQuery("");
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const getSelectedCount = (filterName) => {
    const selectedCount = selectedCheckboxes.filter((item) => {
      const filter = filterOptions.find((filter) => filter.name === filterName);
      return filter.tags.some((tag) => tag.key === item.key);
    }).length;

    return selectedCount > 9 ? "9+" : selectedCount.toString();
  };

  const renderCount = (filterName) => {
    const count = getSelectedCount(filterName);

    return count !== "0" ? <span className="numbercount count">{count}</span> : null;
  };

  const switchFilterOptions = filterOptions.filter((item) => item?.type === "radio");
  const _filterOptions = filterOptions.filter((item) => item?.type !== "radio");

  return (
    <>
      <div className={showfilter ? "filterbox" : "filterbox inactive"}>
        <div className="filterhead">
          <p>
            <FilterIcon /> Filter
          </p>
          <button onClick={handleReset}>Reset</button>
        </div>

        {switchFilterOptions.map((item, index) => {
          return (
            <>
              <div className="createdfilter">
                <div className={`togglebtn createrhead ${index === 0 ? "" : ""}`}>
                  <label
                    htmlFor={`flexSwitchCheckDefault_${index}`}
                    className="w-100"
                    style={{ cursor: "pointer", margin: 0 }}
                  >
                    <p style={{ margin: 0 }}>{item.name}</p>
                    <div className="form-check form-switch simfilterswitch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id={`flexSwitchCheckDefault_${index}`}
                        checked={isChecked(item)}
                        onChange={() => handleCheckboxChange(item)}
                      />
                    </div>
                  </label>
                </div>
              </div>
            </>
          );
        })}

        {_filterOptions.map((filter, index) => (
          <div key={index} className={`createdfilter ${currentTab === index ? "createdactive" : ""}`}>
            <div className="createrhead" onClick={() => setCurrentTab(currentTab === index ? null : index)}>
              <span className="d-flex align-items-center justify-content-start gap-2 position-relative">
                <p>
                  {filter.name}
                  <sup>{renderCount(filter.name)}</sup>{" "}
                </p>
              </span>
              <p>{currentTab === index ? <MinusIcon /> : <PLusIcon />}</p>
            </div>

            {currentTab === index ? (
              <>
                <div className="searchfields form-group position-relative mt-2 mb-1">
                  <span className="searchicon">
                    <SearchIcon />
                  </span>
                  <input
                    type="text"
                    placeholder="Search.."
                    className="form-control"
                    value={searchQuery}
                    onChange={handleSearchChange}
                  />
                  {searchQuery.length > 0 && (
                    <span className="filterSearchCancel searchiconcancel" onClick={() => setSearchQuery("")}>
                      <RemoveIcon />
                    </span>
                  )}
                </div>
                <div className="createdatahere mt-0 pe-2">
                  <div className="checkbox-list">
                    {filter.tags
                      .filter((item) => item.name.toLowerCase().includes(searchQuery.toLowerCase()))
                      .map((item, subIndex) => (
                        <div key={subIndex} className="checkbox-item">
                          <label class="form-check simcheck">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              checked={isChecked(item)}
                              onChange={() => handleCheckboxChange(item)}
                            />
                            <span>{item.name}</span>
                          </label>
                        </div>
                      ))}
                  </div>
                </div>
              </>
            ) : null}
          </div>
        ))}
      </div>

      {showfilter && <div className="showoverlay" onClick={onToggleFilter}></div>}
      {sortingOpen && <div className="showoverlay" onClick={openSorting}></div>}
    </>
  );
};

export default FilterTab;
